import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { convertDateTimeFromServer, convertDateTimeToServer, displayDefaultDateTime } from 'app/shared/util/date-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getUserCashBacks } from 'app/entities/user-cash-back/user-cash-back.reducer';
import { getEntities as getCustomers } from 'app/entities/customer/customer.reducer';
import { CorrectionStatus } from 'app/shared/model/enumerations/correction-status.model';
import { createEntity, getEntity, reset, updateEntity } from './correction.reducer';

export const CorrectionUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const userCashBacks = useAppSelector(state => state.userCashBack.entities);
  const customers = useAppSelector(state => state.customer.entities);
  const correctionEntity = useAppSelector(state => state.correction.entity);
  const loading = useAppSelector(state => state.correction.loading);
  const updating = useAppSelector(state => state.correction.updating);
  const updateSuccess = useAppSelector(state => state.correction.updateSuccess);
  const correctionStatusValues = Object.keys(CorrectionStatus);

  const handleClose = () => {
    navigate(`/correction${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getUserCashBacks({}));
    dispatch(getCustomers({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    values.createdAt = convertDateTimeToServer(values.createdAt);

    const entity = {
      ...correctionEntity,
      ...values,
      userCashBack: userCashBacks.find(it => it.id.toString() === values.userCashBack?.toString()),
      customer: customers.find(it => it.id.toString() === values.customer?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {
          requestDate: displayDefaultDateTime(),
        }
      : {
          status: 'PENDING',
          ...correctionEntity,
          requestDate: convertDateTimeFromServer(correctionEntity.requestDate),
          userCashBack: correctionEntity?.userCashBack?.id,
          customer: correctionEntity?.customer?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tycheApp.correction.home.createOrEditLabel" data-cy="CorrectionCreateUpdateHeading">
            <Translate contentKey="tycheApp.correction.home.createOrEditLabel">Create or edit a Correction</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="correction-id"
                  label={translate('tycheApp.correction.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tycheApp.correction.status')}
                id="correction-status"
                name="status"
                data-cy="status"
                type="select"
              >
                {correctionStatusValues.map(correctionStatus => (
                  <option value={correctionStatus} key={correctionStatus}>
                    {translate(`tycheApp.CorrectionStatus.${correctionStatus}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tycheApp.correction.requestDate')}
                id="correction-requestDate"
                name="requestDate"
                data-cy="requestDate"
                type="datetime-local"
                placeholder="YYYY-MM-DD HH:mm"
              />
              <ValidatedField
                label={translate('tycheApp.correction.errorType')}
                id="correction-errorType"
                name="errorType"
                data-cy="errorType"
                type="text"
              />
              <ValidatedField
                label={translate('tycheApp.correction.assignee')}
                id="correction-assignee"
                name="assignee"
                data-cy="assignee"
                type="text"
              />
              <ValidatedField
                label={translate('tycheApp.correction.correctedDeal')}
                id="correction-correctedDeal"
                name="correctedDeal"
                data-cy="correctedDeal"
                type="text"
              />
              <ValidatedField
                label={translate('tycheApp.correction.remark')}
                id="correction-remark"
                name="remark"
                data-cy="remark"
                type="text"
              />
              <ValidatedField
                id="correction-userCashBack"
                name="userCashBack"
                data-cy="userCashBack"
                label={translate('tycheApp.correction.userCashBack')}
                type="select"
              >
                <option value="" key="0" />
                {userCashBacks
                  ? userCashBacks.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="correction-customer"
                name="customer"
                data-cy="customer"
                label={translate('tycheApp.correction.customer')}
                type="select"
              >
                <option value="" key="0" />
                {customers
                  ? customers.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/correction" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default CorrectionUpdate;
